<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em>For my children,</em><br/><span class="small">ALIISA, MICAH,</span> <em>and</em> <span class="small">ALLISON.</span><br/><em>My sweetest calling, my greatest pride.</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?eb313de8